module.exports = __webpack_public_path__ + "img/kefu.652a7aa2.png";